import { useEffect, useState } from "react";
import { marked } from "marked";
import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/Reveal";

export default function Privacy() {
  useSeo(
    "Privacy Policy | Reform Intelligence®",
    "How Reform Intelligence AI, Inc. collects, uses, and protects information on this website."
  );

  const [html, setHtml] = useState("");

  useEffect(() => {
    fetch("/legal/privacy.md")
      .then((r) => (r.ok ? r.text() : Promise.reject()))
      .then((text) => setHtml(marked.parse(text)))
      .catch(() => setHtml("<p>Privacy policy unavailable.</p>"));
  }, []);

  return (
    <>
      <PageHero eyebrow="Legal" headline="Privacy Policy" subhead="Reform Intelligence AI, Inc. Effective date: September 30, 2026." />
      <section data-testid="privacy-content" className="bg-white">
        <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-20">
          <div className="prose-ri" dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      </section>
    </>
  );
}
